import { MovioTracker } from '@common/classes/movioTracker'
import { cancelOrder } from '@common/utils/cancelOrder'
import { getLogger } from '@omnia/ui/src/lib/services/logger/logger.service'
import type { InProgressStandardOrder } from '@vista-digital/ocapi-types/v1'
import { getOrder, getShowtimeById, orderDomainStore } from '@vista-digital/occ-domain'
import { foodAndBeverageWorkflow } from '@/content/services/workflows/foodAndBeverage/food-and-beverage-workflow'
import { giftStoreWorkflow } from '@/content/services/workflows/giftStore/gift-store-workflow'
import { limitlessWorkflow } from '@/content/services/workflows/limitless/limitless-workflow'
import { ticketingWorkflow } from '@/content/services/workflows/ticketing/ticketing-workflow'
import type {
    AllPagesKeys,
    FoodAndBeverageSubPages,
    GiftStoreSubPages,
    LimitlessPages,
    TicketingSubPages,
} from '../enums/pages.enum'

const logger = getLogger('WorkflowUtilities')

export const abandonOrder = async () => {
    const movioTracker = new MovioTracker()

    const order = getOrder() as InProgressStandardOrder

    if (order?.showtimes && order?.showtimes[0]) {
        const showtime = getShowtimeById(order.showtimes[0].showtimeId)

        if (showtime) {
            void movioTracker.abandonOrder(showtime.filmId)
        }
    }

    // This needs to happen faster
    clearAllWorkflows()

    orderDomainStore.hydrate()
    await cancelOrder()
    orderDomainStore.reset()

    logger.value.info('Order abandoned!')
}

export const clearAllWorkflows = () => {
    ticketingWorkflow.end(false)
    limitlessWorkflow.end()
    giftStoreWorkflow.end()
    foodAndBeverageWorkflow.end()
}

export const onAnyWorkflowPage = (page: AllPagesKeys) =>
    ticketingWorkflow.inWorkflow(page as keyof TicketingSubPages) ||
    limitlessWorkflow.inWorkflow(page as keyof LimitlessPages) ||
    giftStoreWorkflow.inWorkflow(page as keyof GiftStoreSubPages) ||
    foodAndBeverageWorkflow.inWorkflow(page as keyof FoodAndBeverageSubPages)

export const anyWorkflowInProgress = () =>
    ticketingWorkflow.inProgress() ||
    limitlessWorkflow.inProgress() ||
    giftStoreWorkflow.inProgress() ||
    foodAndBeverageWorkflow.inProgress()
